import SetStatesRequestModelBase from '../_generated/modelBases/set-states-request-model-base';

export default class SetStatesRequestModel extends SetStatesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
